import * as Sentry from '@sentry/browser';

export function initSentry(): void {
  Sentry.init({
    dsn: 'https://c754a3753f8a274c9bf0afd0b08af757@o4511632967401472.ingest.de.sentry.io/4511665562189904',
    environment: import.meta.env.VITE_NAME,
    integrations: (integrations) => [
      ...integrations.filter(
        (integration) => integration.name !== 'GlobalHandlers',
      ),
      Sentry.replayIntegration(),
    ],
    replaysOnErrorSampleRate: 1.0,
  });
}
